// extracted by mini-css-extract-plugin
module.exports = {"main":"DaysSelectMenu_main__3fDtq","title":"DaysSelectMenu_title__2YD3M","buttonsNumberInput":"DaysSelectMenu_buttonsNumberInput__1UI5O","close":"DaysSelectMenu_close__1e0kc"};